
import {Colors} from 'bodyspec-shared-components';

export const Routes = {
	_404: '/404',
	account: '/account-settings',
	ambassador: '/ambassador-program',
	assistant: '/assistant',
	blog: '/blog',
	bookedAppointments: '/booked-appointments',
	booking: '/booking',
	bookingSuccess: '/booking-success',
	changePassword: '/change-password',
	checkoutPayment: '/checkout-payment',
	checkoutSetup: '/checkout-setup',
	dashboard: '/dashboard',
	employers: '/employers',
	gifting: '/gifting-center',
	hangout: '/health-hangout',
	harassmentPolicy: '/harassment-policy',
	home: '/',
	pricingBulk: '/pricing-bulk',
	pricingPkgs: '/pricing-packages',
	privacyPolicy: '/privacy-policy',
	referralClaim: '/claim10',
	referrals: '/referrals',
	refundPolicy: '/refund-policy',
	reportBuilder: '/report-builder',
	reportDexa: '/report-dexa/',
	reports: '/reports',
	requestAVan: '/request-a-van',
	resetPassword: '/reset-password',
	resetSuccess: '/reset-success',
	sandbox: '/sandbox',
	scanMe: '/scan-me',
	sharedDexa: '/shared-dexa/',
	signIn: '/sign-in',
	signUp: '/sign-up',
	sitemap: '/sitemap',
	support: '/support',
	survey: '/health-survey',
	termsOfService: '/terms-of-service',
	transactions: '/transactions',
};

export const SUPPORT_INFO = {
	address: '5847 Uplander Way Culver City, CA 90230',
	phone: '+13106018184',
	phoneLabel: '(310) 601-8184',
	email: 'support@bodyspec.com'
};

export const COLORS = {
	BLACK: '#000000',
	GRAY6: '#F2F2F2',
	GRAY9: '#A0A0A0',
	INFOGREEN: '#98C5A2',
	LIGHTPURPLE: '#889CC4',
	NEWDARK55: '#7C8D90',
	NEWDARK: Colors.newdark,
	PRIMARY40: '#A1C878',
	PRIMARY60: Colors.primary60,
	PRIMARY80: Colors.primary80,
	SALAD100: '#69D994',
	SALAD60: Colors.salad60,
	SALAD80: '#B3E5C2',
	SKYBLUE: '#99D3E7',
	WHITE: '#FFFFFF',
};

export const EMAIL_REGEX = (
	/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
);

export const PASSWORD_REGEX = (/(?:(?=.*\d)|(?=.*[A-Z])).{8,255}/);

export const PHONE_REGEX = (/^(\D*\d\D*){10,}$/);

export const AIRTABLES = {
	BLOG_POSTS: 'appF9UEL4Fq04u2VI',
	PARTNERSHIPS: 'appkR2u3Y6DTqbmG1',
	WEB_ASSETS: 'appFK9x2lK6Craayt',
	WEB_REDIRECTS: 'appF8JLHTHIzUHvmB',
};

export const DEFAULT_ERROR_MESSAGE = 'Sorry, we are having issues contacting the server. Please try again.';

// Keep consistent with $sizes in scss
export const SCREEN_SIZES = {
	xs: 320,
	sm: 576,
	md: 768,
	lg: 992,
	xl: 1200,
	xxl: 1440,
	'3xl': 1920,

	nav: 880,
};

export const LINK_EXT = () => ({
	target: '_blank',
	rel: 'noopener noreferrer nofollow',
});

export enum BG {
	transparent = 'transparent',
	dark = 'dark',
	light = 'light',
}

export const BACKGROUND_COLOR: {[key in BG]: string} = {
	[BG.transparent]: 'transparent',
	[BG.dark]: COLORS.NEWDARK,
	[BG.light]: COLORS.SALAD60,
};
